import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { useMemo } from 'react';
import { HotelCategory } from '../../../../../../components/HotelCategory/index.js';
import { Container } from '../../../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/HotelCard/components/Container.js';
import { Image } from '../../../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/HotelCard/components/Image.js';
import { Title } from '../../../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/HotelCard/components/Title.js';
import { PictureFallback } from '../../../../../../components/PictureFallback/index.js';
import { SustainabilityHotelBadge } from '../../../../../../components/Sustainability/HotelBadge/index.js';
import { LabelMediumBold, LabelSmall, Stack } from '../../../../../../primitives/index.js';
import { HOTEL_DETAILS_QA_ID, qaId } from '../../../../../../utils/qaId.js';
export const HotelCard = ({
  image,
  category,
  categoryType,
  name,
  address,
  isSustainable,
  sustainableCertifier
}) => {
  const {
    city = '',
    country = '',
    street = '',
    streetNumber = '',
    region = '',
    zipCode = ''
  } = address || {};
  const mdUp = useBreakpointUp('md');
  const mappedHotelAddress = useMemo(() => {
    return [[street, streetNumber].filter(Boolean).join(' '), [zipCode, city].filter(Boolean).join(', '), [region, country].filter(Boolean).join(', ')].filter(line => line.length > 0);
  }, [street, streetNumber, zipCode, city, region, country]);
  return _jsxs(Container, {
    "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'hotelcard-container'),
    children: [_jsx(Image, {
      children: image ? _jsx("img", {
        src: image,
        alt: name
      }) : _jsx(PictureFallback, {})
    }), _jsxs(Stack, {
      spacing: "xSmall",
      children: [_jsx(HotelCategory, {
        value: category,
        type: categoryType,
        withTooltip: true,
        "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'hotelcard-category')
      }), _jsx(Title, {
        children: _jsxs(LabelMediumBold, {
          "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'hotelcard-title'),
          children: [name, isSustainable && _jsx(SustainabilityHotelBadge, {
            certifyingAuthority: sustainableCertifier,
            size: mdUp ? 'large' : 'medium'
          })]
        })
      }), _jsx("div", {
        children: mappedHotelAddress.map((addressLine, i) => _jsx(LabelSmall, {
          color: "contentSecondary",
          "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'hotelcard-address'),
          children: addressLine
        }, i))
      })]
    })]
  });
};